<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <el-form
      class="form-body"
      :model="form1"
      ref="queryForm"
      label-width="80px"
    >
      <el-row :gutter="20">
        <el-col v-if="false" :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="平台渠道：" prop="dictName">
              <el-select
                clearable
                v-model="systemValue"
                placeholder="请选择"
                size="small"
                @change="loadTableData"
              >
                <el-option
                  v-for="item in systemOption"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
        <el-col :span="8">
          <el-upload
            class="upload-task"
            action=""
            ref="uploadControl"
            :http-request="uploadFile1"
            :on-success="(value) => handleUploadSuccess1(value)"
            :show-file-list="true"
            :file-list="fileList1"
            :before-upload="beforeUpload"
            :limit="1"
            size="small"
          >
            <el-button icon="el-icon-plus" type="primary" size="small"
              >模板导入</el-button
            >
          </el-upload>
        </el-col>
      </el-row>
    </el-form>

    <div class="table-body">
      <div style="overflow:hidden;">
        <div
          class="left"
          style="text-align: left; margin: 0 0 16px 0;color: #606266;line-height: 40px;padding: 0 12px 0 0;font-size: 13px;"
        >
          所属类目：
          <el-cascader
            size="small"
            expand-trigger="hover"
            :options="platTypeList"
            :props="optionProps"
            v-model="form2.platId"
            @change="handleChangePlatId"
          >
          </el-cascader>
        </div>
        <div v-if="platId" class="right">
          <el-button size="small" type="primary" @click="addAttr"
            >新增属性</el-button
          >
          <el-button size="small" type="primary" @click="saveAttr"
            >保存/提交</el-button
          >
        </div>
      </div>
      <vxe-table
        border
        resizable
        show-overflow
        :data="forms"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        v-if="forms.length > 0"
      >
        <vxe-table-column
          v-if="false"
          field="attrId"
          title="属性名ID"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="groupBy"
          title="分组"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="labelName"
          title="中文属性名"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="fieldName"
          title="英文属性名"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="dataType"
          title="数据类型"
          :edit-render="{ name: '$select', options: dataTypeOptions }"
        ></vxe-table-column>
        <vxe-table-column
          field="value"
          title="属性值"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="sortNo"
          title="排序"
          :edit-render="{ name: 'input', attrs: { type: 'text' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="importType"
          title="重要状态"
          :edit-render="{ name: '$select', options: importantStatusOptions }"
        ></vxe-table-column>
        <vxe-table-column
          field="isEffect"
          title="是否启用"
          :edit-render="{ name: '$select', options: isOption }"
        ></vxe-table-column>
        <vxe-table-column title="操作" width="100" show-overflow>
          <template v-slot="{ row }">
            <el-button size="mini" type="text" @click="deleteForm(row)"
              >删除</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div v-if="platId" style="text-align: right; margin-top: 10px">
        <el-button size="small" type="primary" @click="addAttr"
          >新增属性</el-button
        >
        <el-button size="small" type="primary" @click="saveAttr"
          >保存/提交</el-button
        >
      </div>
    </div>

    <div style="margin-top: 10px; margin-bottom: 10px">
      {{ baseAttrValuePath }}
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { listPlatType, uploadTemplate } from "@/api/plat/platType"
import request from "@/utils/request"
import { getProductTypeList } from "@/api/plat/platType"
import { getProList } from "@/api/plat/platType"

export default {
  name: "baseAttr",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      isAdd: false,
      forms: [],
      form1: {},
      form2: { platId: "" },
      baseAttrValuePath: "",
      systemValue: "",
      systemOption: [],
      platTypeList: [],
      optionProps: {
        value: "platId",
        label: "platName",
        children: "childrenTree",
      },
      isOption: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      dataTypeOptions: [
        {
          value: "01",
          label: "文本",
        },
        {
          value: "02",
          label: "单选",
        },
        {
          value: "03",
          label: "多选",
        },
        {
          value: "04",
          label: "文本域",
        },
        {
          value: "05",
          label: "枚举值单选",
        },
        {
          value: "06",
          label: "枚举值多选",
        },
        {
          value: "07",
          label: "时间",
        },
      ],
      importantStatusOptions: [
        {
          value: "Required",
          label: "重要",
        },
        {
          value: "Preferred",
          label: "首选",
        },
        {
          value: "Optional",
          label: "可选",
        },
      ],
      fileList1: [],
      searchValue: [],
      tableData: [],
      tableDataList: [],
      clickTableIndex: 0,
      currentTableIndex: 0,
      treeIndex: [],
      platId: "",
    }
  },
  created() {
    this.getDicts("s_plat_code").then((response) => {
      this.systemOption = response.data
      this.systemValue = response.data[0].dictValue
      //   this.loadTableData()
    })
    this.getPlatTypeList()
  },
  watch: {
    tableDataList(value) {
      let list = []
      value.forEach((item, index) => {
        list[index] = this.searchValue[index]
      })
      this.searchValue = list
    },
  },
  methods: {
    handleChangePlatId(value) {
      let vals = this.getCascaderObj(value, this.platTypeList)
      if (vals.length > 0) {
        let node = vals[vals.length - 1]
        this.platId = node.platId
        this.getTableData(node.platId)
      }
    },
    getTableData(platId) {
      getProList({ platId }).then((response) => {
        response.rows.forEach((form, index) => {
          form.value = ""
          form.sPlatProVals.forEach((value) => {
            form.value += value.valName + ":" + value.engValName + ","
          })
          form.value = form.value.substr(0, form.value.length - 1)
        })
        this.forms = response.rows
      })
    },
    getCascaderObj(val, opt) {
      return val.map(function(value, index, array) {
        for (var itm of opt) {
          if (itm.platId == value) {
            opt = itm.childrenTree
            return itm
          }
        }
        return null
      })
    },
    async getPlatTypeList() {
      let result = await getProductTypeList({platNo: '04'})
      this.platTypeList = result.data
    },
    saveAttr() {
      let that = this
      this.forms.forEach((item) => {
        item.platNo = this.systemValue
        item.catId = this.platId
        item.sPlatProVals = []
        try {
          item.value.split(",").forEach((value, index) => {
            let valName = value.substr(0, value.indexOf(":"))
            let engValName = value.substr(value.indexOf(":") + 1, value.length)
            item.sPlatProVals.push({
              valName: valName,
              engValName: engValName,
              attrId: item.attrId,
              sortNo: index + 1,
            })
          })
        } catch (e) {
          item.sPlatProVals = []
        }
      })
      request({
        url: "/server/pro/addBatch",
        method: "post",
        data: this.forms,
      }).then((data) => {
        if (data.code == 200) {
          that.$message({
            type: "success",
            message: data.msg,
          })
        } else {
          that.$message.error(data.msg)
        }
        that.loadForms()
      })
    },
    addAttr() {
      this.forms.push({
        // attrId: new Date().getTime() + "" + Math.floor(Math.random() * 10), //后端生成
        labelName: "",
        fieldName: "",
        dataType: "",
        value: "",
        sortNo: "",
        importType: "",
        isEffect: "1",
      })
    },
    loadTableData() {
      listPlatType({
        platNo: this.systemValue,
      }).then((response) => {
        this.tableData = this.handleTree(response.data, "platId", "pPlatId")
        this.tableDataList = [this.tableData]
        this.forms = []
      })
    },
    deleteForm(item) {
      let that = this
      if (item.id != undefined) {
        that
          .$confirm("确认要删除该属性？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            request({
              url: "/server/pro/" + item.id,
              method: "delete",
            }).then((data) => {
              that.$message({
                type: "success",
                message: data.msg,
              })
              that.loadForms()
            })
          })
      } else {
        that
          .$confirm("确认要删除该属性？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            that.forms.splice(that.forms.indexOf(item), 1)
          })
      }
    },
    changeTableIndex(index) {
      this.currentTableIndex = index
    },
    rowClick(row) {
      for (let i = 0; i < this.treeIndex.length; i++) {
        if (i > this.currentTableIndex) {
          this.treeIndex[i] = 0
        }
      }
      let clickIndex = this.tableDataList[this.currentTableIndex].findIndex(
        (item) => row.platName == item.platName
      )
      this.treeIndex[this.currentTableIndex] = clickIndex
      for (let i = 0; i < this.tableDataList.length; i++) {
        if (i > this.currentTableIndex) {
          this.tableDataList.splice(i, 1)
        }
      }
      if (
        this.tableDataList[this.currentTableIndex][clickIndex].children !=
          undefined &&
        this.tableDataList[this.currentTableIndex][clickIndex].children !=
          null &&
        this.tableDataList[this.currentTableIndex][clickIndex].children.length >
          0
      ) {
        this.tableDataList.splice(
          this.currentTableIndex + 1,
          1,
          this.tableDataList[this.currentTableIndex][clickIndex].children
        )
      }
      if (row.isLeaf == "1") {
        this.isAdd = true
        this.loadForms()
        this.setBaseAttrValuePath()
      } else {
        this.forms = []
        this.isAdd = false
        this.baseAttrValuePath = ""
      }
    },
    loadForms() {
      let that = this
      that.forms = []
      request({
        url: "/server/pro/list",
        method: "get",
        params: {
          platId: this.platId,
        },
      }).then((response) => {
        response.rows.forEach((form, index) => {
          form.value = ""
          form.sPlatProVals.forEach((value) => {
            form.value += value.valName + ":" + value.engValName + ","
          })
          form.value = form.value.substr(0, form.value.length - 1)
        })
        that.forms = response.rows
      })
    },
    setBaseAttrValuePath() {
      this.$nextTick(() => {
        this.baseAttrValuePath = ""
        this.tableDataList.forEach((item, index) => {
          this.baseAttrValuePath +=
            item[this.treeIndex[index]].platName +
            "(" +
            item[this.treeIndex[index]].engPlatName +
            ") > "
        })
        this.baseAttrValuePath = this.baseAttrValuePath.substring(
          0,
          this.baseAttrValuePath.length - 3
        )
      })
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isLt2M
    },
    async uploadFile1(file) {
      let formData = new FormData()
      formData.append("file", file.file)
      uploadTemplate(formData).then((response) => {
        if (response.code === 200) {
          this.open = false
          this.msgSuccess("导入成功")
        } else {
          this.msgError(response.msg)
        }
      })
    },
    handleUploadSuccess1(response) {
      // this.formTools['file1'] = response.fileUrl;
      this.$refs.uploadControl.clearFiles()
      this.getData()
    },
  },
}
</script>

<style scoped></style>
